import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";
import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

var AppRefreshAndExport = /*#__PURE__*/function (_Vue) {
  _inherits(AppRefreshAndExport, _Vue);

  var _super = _createSuper(AppRefreshAndExport);

  function AppRefreshAndExport() {
    _classCallCheck(this, AppRefreshAndExport);

    return _super.apply(this, arguments);
  }

  _createClass(AppRefreshAndExport, [{
    key: "handleRefresh",
    value: function handleRefresh() {
      if (this.refreshHandler) {
        this.refreshHandler();
      }
    }
  }, {
    key: "handleExport",
    value: function handleExport() {
      if (this.exportHandler) {
        this.exportHandler();
      }
    }
  }]);

  return AppRefreshAndExport;
}(Vue);

__decorate([Prop({
  type: Function
})], AppRefreshAndExport.prototype, "refreshHandler", void 0);

__decorate([Prop({
  type: Function
})], AppRefreshAndExport.prototype, "exportHandler", void 0);

AppRefreshAndExport = __decorate([Component({})], AppRefreshAndExport);
export default AppRefreshAndExport;